/**
 * @namespace source.items
 */
import { toItem } from './mappers/item';
import { toError } from './parsers/error';
import { MediaType } from '../../constants/MediaType';
export function initItems(settings, http) {
  function mapItemList(res, thumbnailSizes) {
    res.data = (res.data.files || []).map(function (data) {
      return toItem(data, settings, thumbnailSizes);
    });
    return res;
  }
  const defaultPaging = {
    size: 50,
    cursor: null
  };
  const defaultSort = {
    order: 'date',
    direction: 'desc'
  };

  //var previousCursor = null;

  /**
   * @summary Returns the list of items from the given folder
   * @memberof source.items
   * @param {string} folderId
   * @param {ListSettings} options
   * @returns {Promise}
   * @fulfill {List}
   * @reject {Error}
   */
  function list(folderId, options) {
    options = options || {};
    const sort = {
      ...defaultSort,
      ...options.sort
    };
    const paging = {
      ...defaultPaging,
      ...options.paging
    };
    const queryParams = {
      page_size: paging.size,
      cursor: paging.cursor,
      parent_folder_id: folderId,
      media_type: options.mediaType || MediaType.Picture
    };
    queryParams.order = sort.direction === 'desc' ? "-" + sort.order : sort.order;
    return http.get(settings.apiUrl + "/files/getpage", queryParams, {
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        size: paging.size,
        //cursor: previousCursor === response.data.cursor ? null : response.data.cursor
        cursor: response.data.cursor
      };

      //previousCursor = response.data.cursor;
      return mapItemList(response, options.thumbnails);
    }).catch(toError);
  }
  function removeItem(itemId, options) {
    const data = {};
    if (settings.ns) {
      data.ns = settings.ns;
    }
    const url = settings.apiUrl + "/files/" + itemId + "/delete";
    const postOptions = {
      headers: options.headers || {}
    };
    return http.post(url, data, null, postOptions).then(function (res) {
      res.data = {
        id: itemId
      };
      return res;
    }).catch(toError);
  }

  /**
   * @summary Removes the items with given ids
   * @memberof source.items
   * @param {Array} itemIds
   * @returns {Array}
   */
  function remove(itemIds, options) {
    options = options || {};
    return itemIds.map(function (itemId) {
      return removeItem(itemId, options);
    });
  }

  /**
   * @summary Return list of items found by tag
   * @memberof source.items
   * @param {string} tag
   * @param {ListSettings} options
   * @returns {Promise}
   * @fulfill {List}
   * @reject {Error}
   */
  function searchByTag(tag, options) {
    options = options || {};
    const sort = {
      ...defaultSort,
      ...options.sort
    };
    const paging = {
      ...defaultPaging,
      ...options.paging
    };
    const queryParams = {
      tag,
      page_size: paging.size,
      cursor: paging.cursor,
      media_type: options.mediaType || MediaType.Picture,
      order: sort.direction === 'desc' ? "-" + sort.order : sort.order
    };
    return http.get(settings.apiUrl + "/files/getpage", queryParams, {
      cache: false,
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        size: paging.size,
        cursor: response.data.cursor
      };
      return mapItemList(response, options.thumbnails);
    }).catch(toError);
  }

  /**
   * @summary Return list of items found by text query
   * @memberof source.items
   * @param {string} folderId
   * @param {string} query
   * @param {ListSettings} options
   * @returns {Promise}
   * @fulfill {List}
   * @reject {Error}
   */
  function search(folderId, query, options) {
    options = options || {};
    const sort = {
      ...defaultSort,
      ...options.sort
    };
    const paging = {
      ...defaultPaging,
      ...options.paging
    };
    const queryParams = {
      query,
      page_size: paging.size,
      cursor: paging.cursor,
      media_type: options.mediaType || MediaType.Picture,
      parent_folder_id: folderId,
      order: sort.direction === 'desc' ? "-" + sort.order : sort.order
    };
    return http.get(settings.apiUrl + "/files/search/getpage", queryParams, {
      cache: false,
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        size: paging.size,
        cursor: response.data.cursor
      };
      return mapItemList(response, options.thumbnails);
    }).catch(toError);
  }
  return {
    list,
    remove,
    searchByTag,
    search
  };
}